// source: wisetime/site/timesheetfield/v1/timesheet_field.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.Icon', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.TimesheetField', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.TimesheetFieldLabelKey', null, global);
goog.exportSymbol('proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest.displayName = 'proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.displayName = 'proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.TimesheetField, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.TimesheetField.displayName = 'proto.wisetime.site.timesheetfield.v1.TimesheetField';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.Icon = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.Icon, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.Icon.displayName = 'proto.wisetime.site.timesheetfield.v1.Icon';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.displayName = 'proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.displayName = 'proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.displayName = 'proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.displayName = 'proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.displayName = 'proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.repeatedFields_, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.displayName = 'proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.repeatedFields_, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.displayName = 'proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.displayName = 'proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.displayName = 'proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest.displayName = 'proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.displayName = 'proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest.displayName = 'proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.repeatedFields_, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.displayName = 'proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.displayName = 'proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.displayName = 'proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.displayName = 'proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest}
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest;
  return proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest}
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    timesheetFieldsList: jspb.Message.toObjectList(msg.getTimesheetFieldsList(),
    proto.wisetime.site.timesheetfield.v1.TimesheetField.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse}
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse;
  return proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse}
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.site.timesheetfield.v1.TimesheetField;
      reader.readMessage(value,proto.wisetime.site.timesheetfield.v1.TimesheetField.deserializeBinaryFromReader);
      msg.addTimesheetFields(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimesheetFieldsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.site.timesheetfield.v1.TimesheetField.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimesheetField timesheet_fields = 1;
 * @return {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetField>}
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.prototype.getTimesheetFieldsList = function() {
  return /** @type{!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetField>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.site.timesheetfield.v1.TimesheetField, 1));
};


/**
 * @param {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetField>} value
 * @return {!proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse} returns this
*/
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.prototype.setTimesheetFieldsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetField=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetField}
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.prototype.addTimesheetFields = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.site.timesheetfield.v1.TimesheetField, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse} returns this
 */
proto.wisetime.site.timesheetfield.v1.ListTimesheetFieldsResponse.prototype.clearTimesheetFieldsList = function() {
  return this.setTimesheetFieldsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.TimesheetField.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetField} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    siteId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    label: jspb.Message.getFieldWithDefault(msg, 3, ""),
    icon: (f = msg.getIcon()) && proto.wisetime.site.timesheetfield.v1.Icon.toObject(includeInstance, f),
    labelKey: jspb.Message.getFieldWithDefault(msg, 6, ""),
    displayOrder: jspb.Message.getFieldWithDefault(msg, 7, 0),
    labelKeyType: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetField}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.TimesheetField;
  return proto.wisetime.site.timesheetfield.v1.TimesheetField.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetField} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetField}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 5:
      var value = new proto.wisetime.site.timesheetfield.v1.Icon;
      reader.readMessage(value,proto.wisetime.site.timesheetfield.v1.Icon.deserializeBinaryFromReader);
      msg.setIcon(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabelKey(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setDisplayOrder(value);
      break;
    case 8:
      var value = /** @type {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldLabelKey} */ (reader.readEnum());
      msg.setLabelKeyType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.TimesheetField.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetField} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getIcon();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.wisetime.site.timesheetfield.v1.Icon.serializeBinaryToWriter
    );
  }
  f = message.getLabelKey();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getDisplayOrder();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getLabelKeyType();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetField} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string site_id = 2;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetField} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string label = 3;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetField} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional Icon icon = 5;
 * @return {?proto.wisetime.site.timesheetfield.v1.Icon}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.getIcon = function() {
  return /** @type{?proto.wisetime.site.timesheetfield.v1.Icon} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.site.timesheetfield.v1.Icon, 5));
};


/**
 * @param {?proto.wisetime.site.timesheetfield.v1.Icon|undefined} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetField} returns this
*/
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.setIcon = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetField} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.clearIcon = function() {
  return this.setIcon(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.hasIcon = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional string label_key = 6;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.getLabelKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetField} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.setLabelKey = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int32 display_order = 7;
 * @return {number}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.getDisplayOrder = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetField} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.setDisplayOrder = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional TimesheetFieldLabelKey label_key_type = 8;
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldLabelKey}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.getLabelKeyType = function() {
  return /** @type {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldLabelKey} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldLabelKey} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetField} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetField.prototype.setLabelKeyType = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.Icon.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.Icon.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.Icon} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.Icon.toObject = function(includeInstance, msg) {
  var f, obj = {
    phosphorId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.Icon}
 */
proto.wisetime.site.timesheetfield.v1.Icon.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.Icon;
  return proto.wisetime.site.timesheetfield.v1.Icon.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.Icon} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.Icon}
 */
proto.wisetime.site.timesheetfield.v1.Icon.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhosphorId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.Icon.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.Icon.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.Icon} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.Icon.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPhosphorId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string phosphor_id = 1;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.Icon.prototype.getPhosphorId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.Icon} returns this
 */
proto.wisetime.site.timesheetfield.v1.Icon.prototype.setPhosphorId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    tagId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    selectedTimesheetFieldOptionIdsList: (f = jspb.Message.getRepeatedField(msg, 3)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest;
  return proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTagId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.addSelectedTimesheetFieldOptionIds(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSelectedTimesheetFieldOptionIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      3,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string tag_id = 2;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.prototype.getTagId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.prototype.setTagId = function(value) {
  return jspb.Message.setField(this, 2, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.prototype.clearTagId = function() {
  return jspb.Message.setField(this, 2, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.prototype.hasTagId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated string selected_timesheet_field_option_ids = 3;
 * @return {!Array<string>}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.prototype.getSelectedTimesheetFieldOptionIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 3));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.prototype.setSelectedTimesheetFieldOptionIdsList = function(value) {
  return jspb.Message.setField(this, 3, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.prototype.addSelectedTimesheetFieldOptionIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 3, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsRequest.prototype.clearSelectedTimesheetFieldOptionIdsList = function() {
  return this.setSelectedTimesheetFieldOptionIdsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    configRefsList: jspb.Message.toObjectList(msg.getConfigRefsList(),
    proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse;
  return proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef;
      reader.readMessage(value,proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.deserializeBinaryFromReader);
      msg.addConfigRefs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigRefsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimesheetFieldConfigRef config_refs = 1;
 * @return {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef>}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.prototype.getConfigRefsList = function() {
  return /** @type{!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef, 1));
};


/**
 * @param {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef>} value
 * @return {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse} returns this
*/
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.prototype.setConfigRefsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef}
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.prototype.addConfigRefs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse} returns this
 */
proto.wisetime.site.timesheetfield.v1.GenerateTimesheetFieldConfigsResponse.prototype.clearConfigRefsList = function() {
  return this.setConfigRefsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.toObject = function(includeInstance, msg) {
  var f, obj = {
    timesheetFieldId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    configHash: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef;
  return proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimesheetFieldId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setConfigHash(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimesheetFieldId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfigHash();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string timesheet_field_id = 1;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.prototype.getTimesheetFieldId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.prototype.setTimesheetFieldId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string config_hash = 2;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.prototype.getConfigHash = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.prototype.setConfigHash = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    configRefsList: jspb.Message.toObjectList(msg.getConfigRefsList(),
    proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest;
  return proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = new proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef;
      reader.readMessage(value,proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.deserializeBinaryFromReader);
      msg.addConfigRefs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getConfigRefsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.serializeBinaryToWriter
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated TimesheetFieldConfigRef config_refs = 2;
 * @return {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef>}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.prototype.getConfigRefsList = function() {
  return /** @type{!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef, 2));
};


/**
 * @param {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef>} value
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest} returns this
*/
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.prototype.setConfigRefsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.prototype.addConfigRefs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsRequest.prototype.clearConfigRefsList = function() {
  return this.setConfigRefsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    timesheetFieldConfigsList: jspb.Message.toObjectList(msg.getTimesheetFieldConfigsList(),
    proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse;
  return proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig;
      reader.readMessage(value,proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.deserializeBinaryFromReader);
      msg.addTimesheetFieldConfigs(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimesheetFieldConfigsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimesheetFieldConfig timesheet_field_configs = 1;
 * @return {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig>}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.prototype.getTimesheetFieldConfigsList = function() {
  return /** @type{!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig, 1));
};


/**
 * @param {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig>} value
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse} returns this
*/
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.prototype.setTimesheetFieldConfigsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.prototype.addTimesheetFieldConfigs = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse} returns this
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldConfigsResponse.prototype.clearTimesheetFieldConfigsList = function() {
  return this.setTimesheetFieldConfigsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.toObject = function(includeInstance, msg) {
  var f, obj = {
    configRef: (f = msg.getConfigRef()) && proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.toObject(includeInstance, f),
    isRequiredField: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    suggestedTimesheetFieldOptionId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    optionsList: jspb.Message.toObjectList(msg.getOptionsList(),
    proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig;
  return proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef;
      reader.readMessage(value,proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.deserializeBinaryFromReader);
      msg.setConfigRef(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsRequiredField(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSuggestedTimesheetFieldOptionId(value);
      break;
    case 4:
      var value = new proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption;
      reader.readMessage(value,proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.deserializeBinaryFromReader);
      msg.addOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getConfigRef();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef.serializeBinaryToWriter
    );
  }
  f = message.getIsRequiredField();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.serializeBinaryToWriter
    );
  }
};


/**
 * optional TimesheetFieldConfigRef config_ref = 1;
 * @return {?proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.getConfigRef = function() {
  return /** @type{?proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef} */ (
    jspb.Message.getWrapperField(this, proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef, 1));
};


/**
 * @param {?proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfigRef|undefined} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig} returns this
*/
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.setConfigRef = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.clearConfigRef = function() {
  return this.setConfigRef(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.hasConfigRef = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool is_required_field = 2;
 * @return {boolean}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.getIsRequiredField = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.setIsRequiredField = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string suggested_timesheet_field_option_id = 3;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.getSuggestedTimesheetFieldOptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.setSuggestedTimesheetFieldOptionId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.clearSuggestedTimesheetFieldOptionId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.hasSuggestedTimesheetFieldOptionId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated TimesheetFieldOption options = 4;
 * @return {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption>}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.getOptionsList = function() {
  return /** @type{!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption, 4));
};


/**
 * @param {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption>} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig} returns this
*/
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.setOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.addOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldConfig.prototype.clearOptionsList = function() {
  return this.setOptionsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    idsList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    fieldId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest;
  return proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addIds(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getIdsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string site_id = 2;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * repeated string ids = 1;
 * @return {!Array<string>}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.prototype.getIdsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.prototype.setIdsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.prototype.addIds = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.prototype.clearIdsList = function() {
  return this.setIdsList([]);
};


/**
 * optional string field_id = 3;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.prototype.getFieldId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.prototype.setFieldId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.prototype.clearFieldId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsRequest.prototype.hasFieldId = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    timesheetFieldOptionsList: jspb.Message.toObjectList(msg.getTimesheetFieldOptionsList(),
    proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse;
  return proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption;
      reader.readMessage(value,proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.deserializeBinaryFromReader);
      msg.addTimesheetFieldOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimesheetFieldOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimesheetFieldOption timesheet_field_options = 1;
 * @return {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption>}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.prototype.getTimesheetFieldOptionsList = function() {
  return /** @type{!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption, 1));
};


/**
 * @param {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption>} value
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse} returns this
*/
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.prototype.setTimesheetFieldOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption}
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.prototype.addTimesheetFieldOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse} returns this
 */
proto.wisetime.site.timesheetfield.v1.BatchGetTimesheetFieldOptionsResponse.prototype.clearTimesheetFieldOptionsList = function() {
  return this.setTimesheetFieldOptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    timesheetFieldId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    externalId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    label: jspb.Message.getFieldWithDefault(msg, 4, ""),
    description: jspb.Message.getFieldWithDefault(msg, 5, ""),
    archived: jspb.Message.getBooleanFieldWithDefault(msg, 6, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption;
  return proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTimesheetFieldId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setExternalId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setArchived(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTimesheetFieldId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 5));
  if (f != null) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getArchived();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string timesheet_field_id = 2;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.getTimesheetFieldId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.setTimesheetFieldId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string external_id = 3;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.getExternalId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.setExternalId = function(value) {
  return jspb.Message.setField(this, 3, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.clearExternalId = function() {
  return jspb.Message.setField(this, 3, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.hasExternalId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional string label = 4;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string description = 5;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.setDescription = function(value) {
  return jspb.Message.setField(this, 5, value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.clearDescription = function() {
  return jspb.Message.setField(this, 5, undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.hasDescription = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional bool archived = 6;
 * @return {boolean}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.getArchived = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption} returns this
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.prototype.setArchived = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest}
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest;
  return proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest}
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    timesheetFieldOptionsList: jspb.Message.toObjectList(msg.getTimesheetFieldOptionsList(),
    proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse}
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse;
  return proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse}
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption;
      reader.readMessage(value,proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.deserializeBinaryFromReader);
      msg.addTimesheetFieldOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimesheetFieldOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimesheetFieldOption timesheet_field_options = 1;
 * @return {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption>}
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.prototype.getTimesheetFieldOptionsList = function() {
  return /** @type{!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption, 1));
};


/**
 * @param {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption>} value
 * @return {!proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse} returns this
*/
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.prototype.setTimesheetFieldOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption}
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.prototype.addTimesheetFieldOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse} returns this
 */
proto.wisetime.site.timesheetfield.v1.ListFavouriteTimesheetFieldOptionsResponse.prototype.clearTimesheetFieldOptionsList = function() {
  return this.setTimesheetFieldOptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest}
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest;
  return proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest}
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    timesheetFieldOptionsList: jspb.Message.toObjectList(msg.getTimesheetFieldOptionsList(),
    proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse}
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse;
  return proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse}
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption;
      reader.readMessage(value,proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.deserializeBinaryFromReader);
      msg.addTimesheetFieldOptions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimesheetFieldOptionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption.serializeBinaryToWriter
    );
  }
};


/**
 * repeated TimesheetFieldOption timesheet_field_options = 1;
 * @return {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption>}
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.prototype.getTimesheetFieldOptionsList = function() {
  return /** @type{!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption, 1));
};


/**
 * @param {!Array<!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption>} value
 * @return {!proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse} returns this
*/
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.prototype.setTimesheetFieldOptionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption=} opt_value
 * @param {number=} opt_index
 * @return {!proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption}
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.prototype.addTimesheetFieldOptions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.wisetime.site.timesheetfield.v1.TimesheetFieldOption, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse} returns this
 */
proto.wisetime.site.timesheetfield.v1.ListRecentTimesheetFieldOptionsResponse.prototype.clearTimesheetFieldOptionsList = function() {
  return this.setTimesheetFieldOptionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fieldOptionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    position: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest}
 */
proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest;
  return proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest}
 */
proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldOptionId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFieldOptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string field_option_id = 2;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.prototype.getFieldOptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.prototype.setFieldOptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 position = 3;
 * @return {number}
 */
proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.AddFavouriteTimesheetFieldOptionRequest.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fieldOptionId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest}
 */
proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest;
  return proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest}
 */
proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldOptionId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFieldOptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string field_option_id = 2;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.prototype.getFieldOptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.RemoveFavouriteTimesheetFieldOptionRequest.prototype.setFieldOptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    siteId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    fieldOptionId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    position: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest}
 */
proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest;
  return proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest}
 */
proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSiteId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setFieldOptionId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSiteId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFieldOptionId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeUint32(
      3,
      f
    );
  }
};


/**
 * optional string site_id = 1;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.prototype.getSiteId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.prototype.setSiteId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string field_option_id = 2;
 * @return {string}
 */
proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.prototype.getFieldOptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.prototype.setFieldOptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional uint32 position = 3;
 * @return {number}
 */
proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest} returns this
 */
proto.wisetime.site.timesheetfield.v1.ReorderFavouriteTimesheetFieldOptionRequest.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * @enum {number}
 */
proto.wisetime.site.timesheetfield.v1.TimesheetFieldLabelKey = {
  TIMESHEET_FIELD_LABEL_KEY_UNSPECIFIED: 0,
  TIMESHEET_FIELD_LABEL_KEY_ACTIVITY: 1,
  TIMESHEET_FIELD_LABEL_KEY_PHASE: 2,
  TIMESHEET_FIELD_LABEL_KEY_BILL_RATE: 3,
  TIMESHEET_FIELD_LABEL_KEY_CUSTOM: 999
};

goog.object.extend(exports, proto.wisetime.site.timesheetfield.v1);
